import BigPicture from 'bigpicture'



const lightview = () => {
  //---------------------------//
  // Gallery LIGHTVIEW
  //---------------------------/
  const imageLinks = document.querySelectorAll('.block-gallery figure');

  if( imageLinks.length > 0 ){
    for (var i = 0; i < imageLinks.length; i++) {
      imageLinks[i].addEventListener('click', function (e) {
        e.preventDefault();
        BigPicture({
          el: e.target,
          galleryAttribute: 'data-full-url',
          gallery: '.block-gallery',
        })
      })
    }
  }

  const old_gallery = document.querySelectorAll('.blocks-gallery-item');
  if( old_gallery.length > 0 ){
    for (let a = 0; a < old_gallery.length; a++) {
      old_gallery[a].addEventListener('click', function (e) {
        e.preventDefault();
        BigPicture({
          el: e.target,
          galleryAttribute: 'data-full-url',
          gallery: '.blocks-gallery-grid',
        })
      })
    }
  }

  const second_old_gallery = document.querySelectorAll('.wp-block-gallery');

  if( second_old_gallery.length > 0 ){
    for (let b = 0; b < second_old_gallery.length; b++) {
      second_old_gallery[b].addEventListener('click', function (e) {
        e.preventDefault();
        BigPicture({
          el: e.target,
          gallery: '.wp-block-gallery',
          galleryAttribute: 'src'
        })
      })
    }
  }


  


}

export default lightview;